import { api } from 'webReservations/api';
import type { FloorPlanData } from '@shared/types/floorPlans';

export enum OfferStatus {
  Active = 'active',
  Accepted = 'accepted',
  Canceled = 'canceled',
}

interface Restaurant {
  id: string;
  name: string;
  description: string;
  address: string;
  phone: string;
  postalCode: string;
  website: string;
  timezone: string;
  locationSlug: string;
  nameSlug: string;
}

export interface Offer {
  date: string;
  expiredAt: string;
  guestCount: number;
  id: string;
  listing: {
    id: string;
    publicName: string;
  };
  price: number;
  restaurant: Restaurant;
  status: OfferStatus;
  transaction?: {
    paymentMethod: string;
  };
  time: string;
}

export interface OfferDetails {
  date: string;
  expiredAt: string;
  guestCount: number;
  id: string;
  listing: {
    id: string;
    publicName: string;
    floorPlan: FloorPlanData;
  };
  price: number;
  restaurant: Restaurant;
  status: OfferStatus;
  time: string;
  transaction: { paymentMethod: string };
}

export const acceptOffer = async (
  offerId: string,
  reservationId: string,
): Promise<void> =>
  api.post(`/offers/${offerId}/accept`, {
    reservationId,
  });

export const rejectOffer = async (
  offerId: string,
  reservationId: string,
): Promise<void> =>
  api.post(`/offers/${offerId}/reject`, {
    reservationId,
  });

export const cancelOffer = async (offerId: string): Promise<void> =>
  api.post(`/offers/${offerId}/cancel`);

export const getOffer = async (offerId: string): Promise<OfferDetails> =>
  api.get(`/offers/${offerId}`);

export const getOffersOut = async (): Promise<Offer[]> => api.get('/offers');
